import * as Immutable from "immutable";
const appConfig = () => window.appConfig || {};
const getEnabledFeatures = () => Immutable.Map(appConfig().featureFlags).filter((value) => value.trim().toLowerCase() === "on").keySeq().toList().filter((s) => typeof s === "string");
const AppConfig = {
  contentStream() {
    var _a;
    return (_a = appConfig()) == null ? void 0 : _a.contentStream;
  },
  features: getEnabledFeatures(),
  gl2ServerUrl() {
    return appConfig().gl2ServerUrl;
  },
  gl2AppPathPrefix() {
    return appConfig().gl2AppPathPrefix;
  },
  gl2DevMode() {
    return typeof DEVELOPMENT !== "undefined" && DEVELOPMENT;
  },
  isFeatureEnabled(feature) {
    return this.features && this.features.map((s) => s.trim().toLowerCase()).includes(feature.toLowerCase());
  },
  rootTimeZone() {
    return appConfig().rootTimeZone;
  },
  isCloud() {
    if (typeof IS_CLOUD !== "undefined") {
      return IS_CLOUD;
    }
    return appConfig().isCloud;
  },
  customThemeColors() {
    var _a, _b, _c;
    return (_c = (_b = (_a = appConfig()) == null ? void 0 : _a.pluginUISettings) == null ? void 0 : _b["org.graylog.plugins.customization.theme"]) != null ? _c : {};
  },
  telemetry() {
    var _a;
    return (_a = appConfig()) == null ? void 0 : _a.telemetry;
  },
  publicNotifications() {
    var _a, _b, _c;
    return (_c = (_b = (_a = appConfig()) == null ? void 0 : _a.pluginUISettings) == null ? void 0 : _b["org.graylog.plugins.customization.notifications"]) != null ? _c : {};
  },
  pluginUISettings(key) {
    var _a, _b, _c;
    return (_c = (_b = (_a = appConfig()) == null ? void 0 : _a.pluginUISettings) == null ? void 0 : _b[key]) != null ? _c : {};
  },
  branding() {
    var _a;
    return (_a = appConfig()) == null ? void 0 : _a.branding;
  },
  globalInputsOnly() {
    return appConfig().globalInputsOnly;
  }
};
export default AppConfig;
